<template>
   <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <MainNav />
                    <header class="page-header page-header-dark bg-gradient-primary-to-secondary">
                        <div class="page-header-content">
                        </div>
                        <div class="svg-border-rounded text-light">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </header>
                    <section class="bg-light py-10">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-10 col-xl-8">
                                    <div class="single-post">
                                        <h1>CD &amp; UC Visit Planners</h1>
                                        <p class="lead">A Visit Planner is a simple tool that helps you get the most out of every doctor visit. It is a brief questionnaire that captures important details and 
                                            questions you have about your Crohn’s disease or ulcerative colitis. 
                                        </p> 
                                        <p><strong>Get Started</strong></p>
                                        <p class="lead">Select your Visit Planner. Complete the brief questionnaire about how you or your child has been feeling. Print this page, and take it to your next doctor visit.</p>
                                        <div class="d-flex align-items-center justify-content-between mb-5">
                                            <div class="single-post-meta mr-4">
                                                <div class="single-post-meta-details">
                                                    <div class="single-post-meta-details-name"><i class="fas fa-tag"></i> Visits</div>
                                                    <div class="single-post-meta-details-date">Feb 5 &#xB7; 6 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row bg-white">
                                            <div class="col-lg-6">
                                                <router-link to="/cd-visit-planner"><img class="img-fluid mb-2" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/263/attachments/original/1582642229/CD_Visit_Planner_new.png?1582642229" /></router-link>
                                            </div>
                                            <div class="col-lg-6">
                                                <router-link to="/uc-visit-planner"><img class="img-fluid mb-2" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/263/attachments/original/1582642229/UC_Visit_Planner_new.png?1582642229" /></router-link>
                                            </div>
                                        </div>
                                        <div class="single-post-text my-5">
                                            <p>Completing a Visit Planner as a part of your doctor visit routine is one way to outsmart IBD and help you or your child feel better.</p>
                                            <div class="text-center"><router-link class="btn btn-transparent-dark btn-marketing rounded-pill" to="/resource-list">Back to Resources</router-link></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                </main>
            </div>
            <div id="layoutDefault_footer">
                <MainFooter />
            </div>
        </div>
</template>

<script>
import $ from 'jquery';
import MainNav from '@/components/nav.vue'
import MainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    MainNav,
    MainFooter
  }
}
// Collapse Navbar
// Add styling fallback for when a transparent background .navbar-marketing is scrolled
var navbarCollapse = function() {
    if($(".navbar-marketing.bg-transparent.fixed-top").length === 0) {
        return;
    }
    if ($(".navbar-marketing.bg-transparent.fixed-top").offset().top > 0) {
        $(".navbar-marketing").addClass("navbar-scrolled");
    } else {
        $(".navbar-marketing").removeClass("navbar-scrolled");
    }
};
// Collapse now if page is not at top
navbarCollapse();
// Collapse the navbar when page is scrolled
$(window).scroll(navbarCollapse);



</script>
